'use strict';

//***********************************************************************************
//***********************************************************************************
//******     CN-Map    **************************************************************
//******     Copyright(C) 2019-2023 EnerBIM                        ******************
//***********************************************************************************
//***********************************************************************************

class cn_logger {
    constructor() {
        this.active = true;
        this.active_perf = true;
    }

    set_active(active) {
        this.active = active;
        this.active_perf = active;
    }

    set_active_perf(active) {
        this.active_perf = active;
    }

    log(...args) {
        if (this.active) {
            console.trace(...args);
        }
    }

    log_fast(...args) {
        if (this.active) {
            console.log(...args);
        }
    }

    warn(...args) {
        if (this.active) {
            console.warn(...args);
        }
    }

    error(...args) {
        if (this.active) {
            console.error(...args);
        }
    }

    time(key) {
        if (this.active_perf) {
            console.time(key);
        }
    }

    timeEnd(key) {
        if (this.active_perf) {
            console.timeEnd(key);
        }
    }

    timeStep(key) {
        if (this.active_perf) {
                console.timeLog(key);
        }
    }

    count(key) {
        if (this.active_perf) {
            console.count(key);
        }
    }
}


export const logger = new cn_logger();
